import { GlossRoutes, NavItem } from "@bitwarden/web-vault/app/models/enum/routes.enum";
import { computed, inject, signal, Signal } from "@angular/core";
import { SignalGlowService } from "@bitwarden/web-vault/app/services/signal-glow/signal-glow.service";

export abstract class Menu {
  protected signalGlowService = inject(SignalGlowService);
  // Single source of truth for selected key
  protected selectedKey = signal("");
  // Menu items signal - child classes should set this
  protected abstract menuItemsSignal: Signal<NavItem[] | null>;

  // Computed signal map for each menu item's signal state to prevent iOS shaking
  protected itemSignalStates = computed(() => {
    const items = this.menuItemsSignal?.();
    if (!items) {
      return new Map<string, boolean>();
    }

    const shouldShow = this.signalGlowService.isSignal();
    const currentSelectedKey = this.selectedKey();
    const signalMap = new Map<string, boolean>();

    items.forEach((item: any) => {
      signalMap.set(
        item.key,
        shouldShow &&
          item.key === GlossRoutes.Account &&
          currentSelectedKey !== GlossRoutes.Account,
      );
    });

    return signalMap;
  });

  protected getSelectedIcon(item: any): string {
    return this.selectedKey() === item.key ? `${item.icon}-selected` : item.icon;
  }

  protected onIsActiveChange(isActive: boolean, key: string) {
    if (isActive) {
      this.selectedKey.set(key);
    }
  }

  protected isSignal(item: NavItem) {
    return this.itemSignalStates().get(item.key) ?? false;
  }
}
